import { render } from "./referals-form.vue?vue&type=template&id=4e5531ec&scoped=true"
import script from "./referals-form.vue?vue&type=script&lang=js"
export * from "./referals-form.vue?vue&type=script&lang=js"

import "./referals-form.vue?vue&type=style&index=0&id=4e5531ec&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5531ec"]])

export default __exports__